import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-papi-types';
import { actionKey } from './constants';
import { pushModal } from '../../../Modals/redux/basicActions';
import { ModalType } from '../../../Modals/redux/types';

export const reduxModuleLoaded = createAction(`${actionKey}.REDUX_READY`, () => ({}));

export const subscribeToTier = createAction(
  `${actionKey}.SUBSCRIBE_TO_TIER`,
  (tier: PapiDeviation) => ({ tier })
);

export const pushUnsubscribeModal = (tier: PapiDeviation) =>
  pushModal(ModalType.TIER_UNSUBSCRIBE, {
    params: { tier },
    wrapInModal: false,
  });

export const pushUnsubscribeModalByUsername = (username: string) =>
  pushModal(ModalType.TIER_UNSUBSCRIBE_BY_USERNAME, {
    params: { username },
    wrapInModal: false,
  });

export const unsubRequestByUsername = createAction(
  `${actionKey}.UNSUBSCRIBE_REQUEST_BY_USERNAME`,
  (username: string) => ({ username })
);

export const unsubRequest = createAction(
  `${actionKey}.UNSUBSCRIBE_REQUEST`,
  (tier: PapiDeviation) => ({ tier })
);

export const overrideSubscribeMatureFilter = createAction(
  `${actionKey}.OVERRIDE_SUBSCRIBE_MATURE_FILTER`,
  (tier: PapiDeviation) => ({ tier })
);

export const changeTier = createAction(
  `${actionKey}.CHANGE_TIER`,
  (currentTier: PapiDeviation, newTier: PapiDeviation) => ({
    currentTier,
    newTier,
  })
);

export const pushChangeTierModal = (
  currentTier: PapiDeviation,
  newTier: PapiDeviation,
  isDowngrade: boolean
) =>
  pushModal(ModalType.TIER_CHANGE, {
    params: { currentTier, newTier, isDowngrade },
  });
